"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkOverride = checkOverride;
exports.checkOverrideGroup = checkOverrideGroup;

var _checks = require("../checks");

var _formatErrors = _interopRequireDefault(require("../utilities/formatErrors"));

var _copyContent = _interopRequireDefault(require("../data/copyContent"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
*   Checks Account Override Input
*   Expected GQL Shape:
*
*   override {
      name: CustomString!
      overrideIdentifier: CustomString!
      overrideTypeId: Int!
      productIds: [Int]!
    }

*   overrideGroup {
      name: CustomString!
      overrideIds: [Int!]
}
*/
function checkOverride(override) {
  const {
    name,
    overrideIdentifier,
    overrideTypeId,
    productIds
  } = override;
  const {
    overrideManagement: {
      missingOverrideName,
      missingOverrideID,
      missingIDType,
      missingProduct
    }
  } = _copyContent.default;
  const checks = {
    name: (0, _checks.checkString)(name, missingOverrideName),
    overrideIdentifier: (0, _checks.checkString)(overrideIdentifier, missingOverrideID),
    overrideTypeId: (0, _checks.checkInteger)(overrideTypeId, missingIDType),
    productIds: productIds.length > 0 || missingProduct
  };
  const errors = (0, _formatErrors.default)(checks);
  return {
    checks,
    errors
  };
}

function checkOverrideGroup(overrideGroup) {
  const {
    name,
    overrideIds
  } = overrideGroup;
  const {
    overrideManagement: {
      missingOverrideGroupName,
      missingOverrideGroupIds
    }
  } = _copyContent.default;
  const checks = {
    name: (0, _checks.checkString)(name, missingOverrideGroupName),
    overrideIds: overrideIds.length > 0 || missingOverrideGroupIds
  };
  const errors = (0, _formatErrors.default)(checks);
  return {
    checks,
    errors
  };
}